import {useSnackbar} from 'notistack';
import * as R from 'ramda';
import React from 'react';
import {ICardData} from '../../CommonInterfaces/Form';
import {AdminElement} from '../../Components/auth/AdminElement';
import {BackButton} from '../../Components/Buttons/BackButton';
import {DeleteButton} from '../../Components/Buttons/DeleteButton';
import {UpdateButton} from '../../Components/Buttons/UpdateButton';
import Card from '../../Components/Card/Card';
import {CardContainer} from '../../Components/CardContainer/CardContainer';
import {RowOfButtons} from '../../Components/Layout/RowOfButtons';
import PageTitle from '../../Components/PageTitle/PageTitle';
import RedirectTo404 from '../../Components/RedirectTo404';
import {makeDeleteHandler} from '../../Helpers/ApiRequestHelper';
import {IPageInterface} from '../entity/IPageInterface';
import {
  EventSubjectEntity,
  useGetEntityDetails,
} from '../entity/useGetEntityDetails';
import {EventSubjectReadFields} from './fields';

/**
 * Event subject's read card.
 * @param {string | undefined} id
 * @return {JSX.Element}
 * @constructor
 */
export default function EventSubjectReadCard({id}: IPageInterface) {
  const empty: ICardData = {};
  const {data, isError} = useGetEntityDetails<ICardData>(
    EventSubjectEntity.name,
    id as string,
    empty);
  const {enqueueSnackbar} = useSnackbar();
  const handleDelete = makeDeleteHandler('EVENT_SUBJECT_DELETE', id as string,
    enqueueSnackbar);

  return (
    <React.Fragment>
      <RedirectTo404 isError={isError}/>

      {!R.isEmpty(data) && data ?
        <PageTitle
          title={`Предмет мероприятия ${data.name}`}/> :
        null}

      <RowOfButtons>
        <BackButton/>
        <AdminElement>
          <DeleteButton handleDelete={handleDelete}/>
          <UpdateButton entity={'event-subject'} id={id as string}/>
        </AdminElement>
      </RowOfButtons>

      {
        data ?
          <CardContainer>
            <Card data={data} fields={EventSubjectReadFields}/>
          </CardContainer> : ''
      }
    </React.Fragment>
  );
}


